module.exports = __webpack_public_path__ + "static/img/lgchem-history-thumb.e74c6d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lgchem-history-thumb.jpg
// module id = yxCO
// module chunks = 0